// extracted by mini-css-extract-plugin
export default {"currency":"CurrencyItem_currency__Mdu8K","currencyName":"CurrencyItem_currencyName__Jau+S"};